import WebinarListItem from "./WebinarListItem"
import { WebinarListItemSkeleton } from "../skeletons"

export default function WebinarList({ 
  webinars = [], 
  loading = false,
  onRegister,
  onCancelRegistration,
  registeringWebinarId = null,
  cancellingWebinarId = null
}) {
  if (loading && webinars.length === 0) {
    return (
      <div className="space-y-4">
        {[...Array(6)].map((_, i) => (
          <WebinarListItemSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (webinars.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">Aucun webinaire disponible</p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {webinars.map((webinar) => (
        <WebinarListItem
          key={webinar.id}
          webinar={webinar}
          onRegister={onRegister}
          onCancelRegistration={onCancelRegistration}
          isRegistering={registeringWebinarId === webinar.id}
          isCancelling={cancellingWebinarId === webinar.id}
        />
      ))}
    </div>
  )
}

